
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySleetShowersDayColour as ObiHeavySleetShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-sleet-showers-day-colour.js';
 
 
 

 
 export const ObiHeavySleetShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-heavy-sleet-showers-day-colour',
   elementClass: ObiHeavySleetShowersDayColourElement,
   events: {
     
   }
  });
 
 